import { Provider } from '@angular/core';
import { APP_LOAD } from '@core/contracts/app-load';
import { UserService } from '@core/user/user.service';

export const userProviders: Provider[] = [
  {
    provide: APP_LOAD,
    useClass: UserService,
    multi: true,
  },
];
